import { useInfiniteQuery } from "@tanstack/react-query";
import { AuthContextValue, useAuth } from "../providers/AuthProvider";
import axiosBaseURL from "../api";

export const useProductList = (options?: {
  search?: string;
  status?: string;
  size?: number;
}) => {
  const { user } = useAuth() as AuthContextValue;

  return useInfiniteQuery({
    queryKey: [
      "useProductList",
      options?.search,
      options?.status,
      options?.size,
    ].filter(Boolean),
    queryFn: async ({ pageParam = 0 }) => {
      const queryParams = new URLSearchParams();
      queryParams.append("page", pageParam.toString());
      queryParams.append("size", (options?.size || 10).toString());
      if (options?.status) queryParams.append("status", options.status);
      if (options?.search) queryParams.append("search", options.search);

      const url = `/off-taker/product?${queryParams.toString()}`;
      const response = await axiosBaseURL.get(url, {
        headers: { header: `${user?.userId}/${user?.token}` },
      });

      return response.data;
    },
    getNextPageParam: (lastPage: any) => {
      const currentPage = lastPage.data?.number ?? lastPage.number;
      const totalPages = lastPage.data?.totalPages ?? lastPage.totalPages;

      if (currentPage + 1 < totalPages) {
        return currentPage + 1;
      }

      return undefined;
    },
    initialPageParam: 0,
    staleTime: 120_000,
  });
};
